import React from 'react';
import { motion } from 'framer-motion';
export interface CTAButtonProps {
  text: string;
  variant?: 'primary' | 'secondary' | 'light';
  onClick?: () => void;
  href?: string;
  className?: string;
}
export function CTAButton({
  text,
  variant = 'primary',
  onClick,
  href,
  className = ''
}: CTAButtonProps) {
  const baseStyles = 'inline-flex items-center justify-center rounded-full px-8 py-4 text-lg font-semibold transition-colors duration-300 text-center cursor-pointer';
  const variants = {
    primary: 'bg-terracotta text-white shadow-lg shadow-terracotta/20 hover:bg-terracotta-dark',
    secondary: 'border-2 border-terracotta text-terracotta hover:bg-terracotta hover:text-white',
    light: 'bg-white text-terracotta shadow-xl hover:bg-cream'
  };
  const handleClick = () => {
    if (href) {
      const el = document.getElementById(href.replace('#', ''));
      if (el) {
        el.scrollIntoView({
          behavior: 'smooth',
          block: 'center'
        });
      }
    }
    if (onClick) onClick();
  };
  return <motion.button whileHover={{
    scale: 1.02
  }} whileTap={{
    scale: 0.98
  }} onClick={handleClick} className={`${baseStyles} ${variants[variant]} ${className}`} data-id="element-26">
      {text}
    </motion.button>;
}